import {Box} from '@material-ui/core'
import Type from 'app/components/proposal/Type'
import _t, {_} from 'i18n'
import React from 'react'
import {Button} from 'react-bootstrap'
import {useHistory, useLocation} from 'react-router-dom'

import {BottomItemValue, ContainerHeader, DetailContainer, Paper} from '../styles'

const formatNumber = (amount) => new Intl.NumberFormat('pt-BR').format(amount)

const LinkedProposals = ({ranking, id, code, state}) => {
  const history = useHistory()

  return (
    <Paper>
      <ContainerHeader>
        {_`Oportunidades vinculadas`}
        {ranking ? (
          <span style={{fontSize: 18}}>
            {_`Ranking de Atratividade de Investimentos`}: <span style={{fontWeight: 'normal'}}>{_`Posição`}</span>{' '}
            {ranking.ranking.position}{' '}
            <span style={{fontWeight: 'normal'}}>
              {_t('de {{total}}', {total: formatNumber(ranking.ranking.total_of_cities)})}
            </span>{' '}
          </span>
        ) : null}
      </ContainerHeader>
      <DetailContainer>
        <table className="table city">
          <thead>
            <tr>
              <th scope="col">
                <span className="text-muted"></span>
              </th>
              <th scope="col">
                <span
                  className="d-flex justify-content-center text-center"
                  style={{color: '#8C8C8C', fontFamily: 'Nunito', fontSize: 15, fontWeight: 'normal'}}>
                  {_`Quantidade`}
                </span>
              </th>
              <th scope="col">
                <span
                  className="d-flex justify-content-center text-center"
                  style={{color: '#8C8C8C', fontFamily: 'Nunito', fontSize: 15, fontWeight: 'normal'}}>
                  {_`Oportunidades`}
                  <br />
                  {_`Ativas`}
                </span>
              </th>
              <th scope="col">
                <span
                  className="d-flex justify-content-center text-center"
                  style={{color: '#8C8C8C', fontFamily: 'Nunito', fontSize: 15, fontWeight: 'normal'}}>
                  {_`Oportunidades`}
                  <br />
                  {_`Ganhas / Concretizadas`}
                </span>
              </th>
              <th scope="col">
                <span
                  className="d-flex justify-content-center text-center"
                  style={{color: '#8C8C8C', fontFamily: 'Nunito', fontSize: 15, fontWeight: 'normal'}}>
                  {_`Ranking`}
                  <br />
                  {_`Estadual`}
                </span>
              </th>
              <th scope="col">
                <span
                  className="d-flex justify-content-center text-center"
                  style={{color: '#8C8C8C', fontFamily: 'Nunito', fontSize: 15, fontWeight: 'normal'}}>
                  {_`Ranking`}
                  <br />
                  {_`Nacional`}
                </span>
              </th>
              <th scope="col">
                <span className="text-muted"></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-middle">
                <Box display="flex" alignItems="center">
                  <Box
                    style={{
                      backgroundColor: '#D4E2F0',
                      marginRight: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    borderRadius="5px"
                    width="46px"
                    height="46px">
                    <i className="fas fa-building" style={{color: '#2C6EB5'}}></i>
                  </Box>

                  <label>
                    <b>{_`Oportunidades Privadas`}</b>
                  </label>
                </Box>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.private.total)}
                </BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>{formatNumber(ranking.proposals.private.open)}</BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.private.completed)}
                </BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.private.ranking.state)}
                  <span style={{verticalAlign: 'super', fontSize: 8}}>o</span>
                </BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.private.ranking.national)}
                  <span style={{verticalAlign: 'super', fontSize: 8}}>o</span>
                </BottomItemValue>
              </td>
              <td className="align-middle text-center" style={{padding: 0}}>
                <Button
                  onClick={() => history.push(`/proposals#filters=type:company&ufs:${state.id}&city:${id}`)}
                  variant="primary">
                  {_`Ver oportunidades`}
                </Button>
              </td>
            </tr>
            <tr>
              <td className="align-middle">
                <Box display="flex" alignItems="center">
                  <Box
                    style={{
                      backgroundColor: '#D4E2F0',
                      marginRight: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    borderRadius="5px"
                    width="46px"
                    height="46px">
                    <i className="fas fa-university" style={{color: '#2C6EB5'}}></i>
                  </Box>
                  <label>
                    <b>{_`Oportunidades Públicas`}</b>
                  </label>
                </Box>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>{formatNumber(ranking.proposals.public.total)}</BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>{formatNumber(ranking.proposals.public.open)}</BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.public.completed)}
                </BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.public.ranking.state)}
                  <span style={{verticalAlign: 'super', fontSize: 8}}>o</span>
                </BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.public.ranking.state)}
                  <span style={{verticalAlign: 'super', fontSize: 8}}>o</span>
                </BottomItemValue>
              </td>
              <td className="align-middle text-center">
                <BottomItemValue style={{fontSize: 15}}>
                  {formatNumber(ranking.proposals.public.ranking.national)}
                  <span style={{verticalAlign: 'super', fontSize: 8}}>o</span>
                </BottomItemValue>
              </td>
              <td className="align-middle text-center" style={{padding: 0}}>
                <Button
                  variant="primary"
                  disabled={ranking.proposals.public.total === 0}
                  onClick={() => history.push(`/proposals#filters=type:city&ufs:${state.id}&city:${id}`)}>
                  {_`Ver oportunidades`}
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </DetailContainer>
    </Paper>
  )
}

export default LinkedProposals
